import { WarningAmber } from "@mui/icons-material";
import { Box, Tooltip, Typography } from "@mui/material";
import { GRID_BORDER } from "../../utils/dayHourGrid";

type Props = {
	assetName: string;
	accentColor: string;
	errorMessage: string | null;
	height: number;
	dimmed: boolean;
	onClick: () => void;
};

export const DayRowLabel = ({
	assetName,
	accentColor,
	errorMessage,
	height,
	dimmed,
	onClick,
}: Props) => (
	<Box
		onClick={onClick}
		sx={{
			minHeight: height,
			display: "flex",
			alignItems: "center",
			borderLeft: `4px solid ${accentColor}`,
			borderRight: GRID_BORDER,
			borderBottom: GRID_BORDER,
			pl: 1,
			pr: 0.5,
			cursor: "pointer",
			opacity: dimmed ? 0.55 : 1,
		}}
	>
		<Typography variant="body2" noWrap sx={{ fontWeight: 600 }}>
			{assetName}
		</Typography>
		{errorMessage && (
			<Tooltip title={errorMessage}>
				<WarningAmber color="warning" sx={{ fontSize: 16, ml: 0.5 }} />
			</Tooltip>
		)}
	</Box>
);
